import React from "react";

import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";
import { Input, InputProps } from "@samskip/frontend-components";
import { useTranslation } from "react-i18next";

type SearchProps = Omit<InputProps, "adornmentRight">;

const CompanyPickerSearchInput = ({ placeholder, ...rest }: SearchProps) => {
  const { t } = useTranslation();
  const customPlaceholder = placeholder ?? `${t("LABEL_SEARCH")}...`;
  return (
    <Input
      {...rest}
      adornmentRight={{ icon: faMagnifyingGlass }}
      placeholder={customPlaceholder}
    />
  );
};

export default CompanyPickerSearchInput;
